import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, resolveDynamicComponent as _resolveDynamicComponent, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "page-with-side-bar-internal-navigation__title"
}
const _hoisted_2 = { class: "page-with-side-bar-internal-navigation__title page-with-side-bar-internal-navigation__title--narrow" }

import { computed } from 'vue';
import { useRoute, useRouter, type RouteRecordName } from 'vue-router';

import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';

import HeaderMobile from './app-header/HeaderMobile.vue';
import useNavigationLinks from './app-header/useNavigationLink';
import InternalNavigation from './InternalNavigation.vue';
import PageWithSideBar from './PageWithSideBar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageWithSideBarInternalNavigation',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const { isXS } = useMQBreakpoints();
const { navLinks } = useNavigationLinks();

const showLeftNav = computed(() => !isXS.value);

const links = computed(() => {
  const { settings, levels, partners, exports, help, blog, legal, keyInformationDocuments } = navLinks.value;

  return {
    primary: [settings, levels, partners, exports],
    secondary: [help, blog, legal, keyInformationDocuments],
  };
});

const title = computed(() => {
  const getMainName = (name?: string | RouteRecordName | null) => {
    if (!name || typeof name === 'symbol') {
      return '';
    }

    return name.split('.')[0] || '';
  };
  const mainRouteName = getMainName(route.name);

  return links.value.primary.find((link) => getMainName(link.route?.name) === mainRouteName)?.pageTitle;
});

const onMobileGoBack = () => {
  router.push({
    name: 'mobile-profile',
  });
};

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(PageWithSideBar, {
    class: "page-with-side-bar-internal-navigation",
    "show-left-nav": showLeftNav.value
  }, {
    leftNav: _withCtx(() => [
      _createVNode(InternalNavigation, {
        class: "page-with-side-bar-internal-navigation__left-nav",
        links: links.value
      }, null, 8, ["links"])
    ]),
    default: _withCtx(() => [
      (title.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (showLeftNav.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(title.value), 1))
              : (_openBlock(), _createBlock(HeaderMobile, {
                  key: 1,
                  class: "page-with-side-bar-internal-navigation__header",
                  onGoBack: onMobileGoBack
                }, {
                  "top-content": _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(title.value), 1)
                  ]),
                  _: 1
                }))
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_router_view, { name: "default" }, {
        default: _withCtx(({ Component }) => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { class: "page-with-side-bar-internal-navigation__section-main" }))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show-left-nav"]))
}
}

})